module.exports = __webpack_public_path__ + "static/media/p5_5.a84ae255.png";